import { useEffect } from 'react';

const globalStyleMap = new Map<string, HTMLStyleElement>();
const globalStyleMountedCount = new WeakMap<HTMLStyleElement, number>();

function createAndMountStyleEl(styles: string) {
  let el = document.createElement('style');
  el.appendChild(document.createTextNode(styles));
  document.head.appendChild(el);
  globalStyleMap.set(styles, el);
  return el;
}

export function useGlobalStyles(styles: string) {
  useEffect(() => {
    let el = globalStyleMap.get(styles) || createAndMountStyleEl(styles);
    let mountedCount = globalStyleMountedCount.get(el) || 0;
    globalStyleMountedCount.set(el, mountedCount + 1);
    return () => {
      let mountedCount = globalStyleMountedCount.get(el) || 0;
      mountedCount = Math.max(0, mountedCount - 1);
      globalStyleMountedCount.set(el, mountedCount);
      if (mountedCount === 0) {
        el.remove();
        globalStyleMap.delete(styles);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
